// usePDA1072_R01Store.ts
import { create } from "zustand";
import {
  PDA1072_R01HeaderDto,
  PDA1072_R01SearchParams,
  PDA1072_R01Dto,
  PDA1072_R01BomLotDto,
  SelectedBomLot,
} from "./PDA1072_R01Dto";

export interface PDA1072_R01Store {
  workOrderList: PDA1072_R01HeaderDto[];
  loading: boolean;
  searchParams: PDA1072_R01SearchParams;

  showList: boolean;
  selectedWorkOrder: PDA1072_R01HeaderDto | null;
  workOrderDetail: PDA1072_R01Dto | null;

  lotNo: string;
  scannedBomLot: PDA1072_R01BomLotDto | null;

  selectedBomLots: SelectedBomLot[];

  setWorkOrderList: (list: PDA1072_R01HeaderDto[]) => void;
  setLoading: (loading: boolean) => void;
  setSearchParams: (params: PDA1072_R01SearchParams) => void;
  updateSearchParam: (field: keyof PDA1072_R01SearchParams, value: string) => void;
  resetSearchParams: () => void;

  setShowList: (show: boolean) => void;
  setSelectedWorkOrder: (order: PDA1072_R01HeaderDto | null) => void;
  setWorkOrderDetail: (detail: PDA1072_R01Dto | null) => void;

  setLotNo: (v: string) => void;
  setScannedBomLot: (b: PDA1072_R01BomLotDto | null) => void;

  addSelectedBomLot: (lot: SelectedBomLot) => void;
  removeSelectedBomLot: (lotNo: string) => void;
  clearSelectedBomLots: () => void;

  resetDetail: () => void;
  reset: () => void;
}

const formatLocalDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const today = new Date();
const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

const initialSearchParams: PDA1072_R01SearchParams = {
  startDate: formatLocalDate(firstDay),
  endDate: formatLocalDate(today),
  productOrderNo: "",
  workplaceCd: "",
  itemCd: "",
};

const usePDA1072_R01Store = create<PDA1072_R01Store>((set) => ({
  workOrderList: [],
  loading: false,
  searchParams: initialSearchParams,
  showList: true,
  selectedWorkOrder: null,
  workOrderDetail: null,
  lotNo: "",
  scannedBomLot: null,
  selectedBomLots: [],

  setWorkOrderList: (list) => set({ workOrderList: list }),
  setLoading: (loading) => set({ loading }),
  setSearchParams: (params) => set({ searchParams: params }),
  updateSearchParam: (field, value) =>
    set((state) => ({ searchParams: { ...state.searchParams, [field]: value } })),
  resetSearchParams: () => set({ searchParams: initialSearchParams }),

  setShowList: (show) => set({ showList: show }),
  setSelectedWorkOrder: (order) => set({ selectedWorkOrder: order }),
  setWorkOrderDetail: (detail) => set({ workOrderDetail: detail }),

  setLotNo: (v) => set({ lotNo: v }),
  setScannedBomLot: (b) => set({ scannedBomLot: b }),

  addSelectedBomLot: (lot) =>
    set((state) => ({ selectedBomLots: [...state.selectedBomLots, lot] })),
  removeSelectedBomLot: (lotNo) =>
    set((state) => ({
      selectedBomLots: state.selectedBomLots.filter((m) => m.lotNo !== lotNo),
    })),
  clearSelectedBomLots: () => set({ selectedBomLots: [] }),

  resetDetail: () =>
    set({
      selectedWorkOrder: null,
      workOrderDetail: null,
      lotNo: "",
      scannedBomLot: null,
      selectedBomLots: [],
    }),

  reset: () =>
    set({
      workOrderList: [],
      loading: false,
      searchParams: initialSearchParams,
      showList: true,
      selectedWorkOrder: null,
      workOrderDetail: null,
      lotNo: "",
      scannedBomLot: null,
      selectedBomLots: [],
    }),
}));

export default usePDA1072_R01Store;
